// ============================================================================
// VILLA - Mock Data per Demo
// Importa dall'authoritative mock-data.json + dati supplementari
// ============================================================================

import mockData from '~/demo-docs/mock-data.json'

// ---------------------------------------------------------------------------
// RE-EXPORT FROM JSON (authoritative source)
// ---------------------------------------------------------------------------

export const facilities = mockData.facility
export const units = mockData.unit
export const services = mockData.service
export const professionalRoles = mockData.professional_role
export const serviceUnits = mockData.service_unit
export const sharedServices = mockData.shared_service
export const users = mockData.user
export const userRoles = mockData.user_role
export const operators = mockData.operator
export const operatorServices = mockData.operator_service
export const guests = mockData.guest
export const guestServices = mockData.guest_service
export const roleDefaultPermissions = mockData.role_default_permission
export const userPermissions = mockData.user_permission
export const activityTypes = mockData.activity_type
export const activityEvents = mockData.activity_event
export const appointments = mockData.appointment
export const diaryEntryGuests = mockData.diary_entry_guest
export const diaryEntryOperators = mockData.diary_entry_operator
export const incidentGuests = mockData.incident_guest
export const incidentOperators = mockData.incident_operator
export const lifeProjects = mockData.life_project
export const lifeProjectObjectives = mockData.life_project_objective
export const alerts = mockData.alert
export const alertReads = mockData.alert_read
export const operatorHistory = mockData.operator_history
export const operatorAttachments = mockData.operator_attachment
export const guestTransferRequests = mockData.guest_transfer_request
export const guestHistory = mockData.guest_history
export const guestAttachments = mockData.guest_attachment

// ---------------------------------------------------------------------------
// ENRICHED EXPORTS — add _guests, _operators, _meta for page compatibility
// ---------------------------------------------------------------------------

export const diaryEntries = mockData.diary_entry.map((de) => ({
   ...de,
   _guests: mockData.diary_entry_guest
      .filter((deg) => deg.diary_entry_id === de.id)
      .map((deg) => deg.guest_id),
   _operators: mockData.diary_entry_operator
      .filter((deo) => deo.diary_entry_id === de.id)
      .map((deo) => deo.operator_id),
   _meta: {
      created_by: de.created_by,
      created_at: de.created_at,
      updated_by: de.updated_by,
      updated_at: de.updated_at,
   },
}))

export const incidents = mockData.incident.map((inc) => ({
   ...inc,
   _guests: mockData.incident_guest
      .filter((ig) => ig.incident_id === inc.id)
      .map((ig) => ({ guest_id: ig.guest_id, role: ig.role })),
   _operators: mockData.incident_operator
      .filter((io) => io.incident_id === inc.id)
      .map((io) => io.operator_id),
   _meta: {
      created_by: inc.created_by,
      created_at: inc.created_at,
      updated_by: inc.updated_by,
      updated_at: inc.updated_at,
   },
}))

// Registry aliases (pages use registryThreads/registryEntries and threads/threadEntries)
export const registryThreads = mockData.thread
export const threads = mockData.thread
export const registryEntries = mockData.thread_entry.map((te) => ({
   ...te,
   date: te.created_at,
   _meta: {
      created_by: te.created_by,
      created_at: te.created_at,
      updated_by: te.updated_by,
      updated_at: te.updated_at,
   },
}))
export const threadEntries = registryEntries

// ---------------------------------------------------------------------------
// GROUPS (not in JSON, used by Anagrafiche)
// ---------------------------------------------------------------------------

export const groups = [
   { id: 'grp_infermieri', facility_id: 'fac_domus', name: 'Infermieri', description: 'Gruppo infermieristico' },
   { id: 'grp_educatori', facility_id: 'fac_domus', name: 'Educatori', description: 'Gruppo educativo' },
   { id: 'grp_riab', facility_id: 'fac_domus', name: 'Riabilitazione', description: 'Gruppo riabilitativo' },
   { id: 'grp_edu_c', facility_id: 'fac_cascina', name: 'Educatori Cascina', description: 'Gruppo educativo Cascina' },
   { id: 'grp_riab_v', facility_id: 'fac_villa', name: 'Riabilitazione Villa', description: 'Gruppo riabilitativo Villa Mossa' },
]

// ---------------------------------------------------------------------------
// GUEST_CONTACTS (supplemental - not in JSON, used by guest detail)
// ---------------------------------------------------------------------------

export const guestContacts = [
   {
      id: 'gc_1', guest_id: 'gst_marchetti', name: 'Marchetti Teresa',
      relationship: 'Nonna materna', phone: '015 456001',
      email: 'contatto1@example.com', is_primary: true,
      notes: 'Visite regolari durante la settimana',
   },
   {
      id: 'gc_2', guest_id: 'gst_marchetti', name: 'Marchetti Lucia',
      relationship: 'Madre', phone: '340 9001001',
      is_primary: false, notes: 'Visite nei weekend',
   },
   {
      id: 'gc_3', guest_id: 'gst_morandi', name: 'Morandi Rosa',
      relationship: 'Madre', phone: '340 9002002',
      email: 'r.morandi.famiglia@gmail.com', is_primary: true,
      notes: 'Familiare con accesso al portale',
   },
   {
      id: 'gc_4', guest_id: 'gst_morandi', name: 'Dott.ssa Bianchi Laura',
      relationship: 'Medico curante', phone: '015 456222',
      is_primary: false,
   },
   {
      id: 'gc_5', guest_id: 'gst_ferretti', name: 'Ferretti Marco',
      relationship: 'Padre', phone: '340 9003003',
      is_primary: true, notes: 'Tutore legale',
   },
   {
      id: 'gc_6', guest_id: 'gst_ricci', name: 'Ricci Alberto',
      relationship: 'Padre', phone: '340 9004004',
      email: 'contatto6@example.com', is_primary: true,
   },
   {
      id: 'gc_7', guest_id: 'gst_fabbri', name: 'Fabbri Elena',
      relationship: 'Madre', phone: '340 9005005',
      email: 'contatto7@example.com', is_primary: true,
   },
   {
      id: 'gc_8', guest_id: 'gst_gentile', name: 'Gentile Sergio',
      relationship: 'Fratello', phone: '340 9006006',
      is_primary: true,
   },
   {
      id: 'gc_9', guest_id: 'gst_bellini', name: 'Bellini Lucia',
      relationship: 'Madre', phone: '340 9007007',
      email: 'contatto9@example.com', is_primary: true,
   },
   {
      id: 'gc_10', guest_id: 'gst_valentini', name: 'Valentini Lucia',
      relationship: 'Moglie (Tutore)', phone: '340 9008008',
      is_primary: true, notes: 'Tutore legale',
   },
]

// ---------------------------------------------------------------------------
// GUEST_HEALTH (supplemental - not in JSON, used by guest detail)
// ---------------------------------------------------------------------------

export const guestHealth = [
   {
      id: 'gh_marchetti', guest_id: 'gst_marchetti',
      therapy_summary: 'Terapia farmacologica complessa per sindrome ansioso-depressiva e anemia sideropenica',
      diet: 'Dieta iposodica, consistenza morbida', allergies: 'HbsAb+',
      emergency_notes: 'ALIMENTAZIONE ENTERALE NUTRISON ML 850 VEL 90 ML/H (NOTTURNA)',
      referring_doctor: 'Dott. Medico 1 - Cod. Reg. 21245U',
      contraindications: 'Evitare FANS per gastropatia', devices_in_use: 'PEG, carrozzina posturale',
   },
   {
      id: 'gh_morandi', guest_id: 'gst_morandi',
      therapy_summary: 'Terapia per ipertensione e diabete tipo 2',
      diet: 'Dieta diabetica ipocalorica', allergies: 'Penicillina',
      emergency_notes: 'Diabetico insulino-dipendente. Monitorare glicemia prima di ogni pasto.',
      referring_doctor: 'Dott.ssa Medico 2',
   },
   {
      id: 'gh_ferretti', guest_id: 'gst_ferretti',
      therapy_summary: 'Epilessia in trattamento con politerapia anticomiziale',
      diet: 'Dieta libera, consistenza normale', allergies: 'Nessuna nota',
      emergency_notes: 'In caso di crisi >5 min somministrare Micropam 10mg per via rettale.',
      referring_doctor: 'Dott. Medico 3',
   },
   {
      id: 'gh_fabbri', guest_id: 'gst_fabbri',
      therapy_summary: 'Disturbo dello spettro autistico con agitazione psicomotoria. In trattamento con risperidone.',
      diet: 'Dieta libera, preferisce cibi morbidi',
      emergency_notes: 'In caso di crisi comportamentale NON contenere fisicamente. Usare strategia di de-escalation verbale.',
      referring_doctor: 'Dott.ssa Medico 4',
   },
   {
      id: 'gh_gentile', guest_id: 'gst_gentile',
      therapy_summary: 'Encefalopatia con tetraparesi spastica. Terapia antispastica.',
      diet: 'Dieta semiliquida, consistenza cremosa', allergies: 'Nessuna nota',
      emergency_notes: 'Aspirare secrezioni se SpO2 < 92%. Posizionamento laterale in caso di vomito.',
      referring_doctor: 'Dott. Medico 1',
      devices_in_use: 'Carrozzina posturale, aspiratore portatile',
   },
   {
      id: 'gh_valentini', guest_id: 'gst_valentini',
      therapy_summary: 'Esiti di ictus ischemico con emiparesi dx. Terapia antiaggregante e antiipertensiva.',
      diet: 'Dieta iposodica', allergies: 'Nessuna nota',
      referring_doctor: 'Dott.ssa Medico 2',
      devices_in_use: 'Deambulatore, calze elastiche',
   },
]

// ---------------------------------------------------------------------------
// MEDICATIONS (supplemental - not in JSON, used by guest detail)
// ---------------------------------------------------------------------------

export const medications = [
   // Marchetti Laura
   { id: 'med_1', guest_id: 'gst_marchetti', name: 'GARDENALE 50 MG', dosage: 'C.1', slot: 'breakfast', start_date: '2017-09-19', is_active: true },
   { id: 'med_2', guest_id: 'gst_marchetti', name: 'RIVOTRIL 2 MG', dosage: 'C. 1/2', slot: 'breakfast', start_date: '2014-11-22', is_active: true },
   { id: 'med_3', guest_id: 'gst_marchetti', name: 'ZONEGRAN 100 MG', dosage: 'C. 2', slot: 'breakfast', start_date: '2016-10-01', is_active: true },
   { id: 'med_4', guest_id: 'gst_marchetti', name: 'LEVETIRACETAM 500 MG', dosage: 'C.1', slot: 'breakfast', start_date: '2022-08-10', is_active: true },
   { id: 'med_5', guest_id: 'gst_marchetti', name: 'MOVICOL B', dosage: '1/2 IN 100 CC DI ACQUA', slot: 'breakfast', start_date: '2022-08-10', is_active: true },
   { id: 'med_6', guest_id: 'gst_marchetti', name: 'ZOLOFT 100 mg', dosage: 'C. 2', slot: 'breakfast', start_date: '2023-01-15', is_active: true },
   { id: 'med_7', guest_id: 'gst_marchetti', name: 'OMEPRAZOLO 20 mg', dosage: 'C. 1', slot: 'breakfast', start_date: '2023-01-15', is_active: true },
   { id: 'med_8', guest_id: 'gst_marchetti', name: 'OLIO DI VASELINA', dosage: 'CUCCH. 1', slot: 'lunch', start_date: '2020-05-01', is_active: true },
   { id: 'med_9', guest_id: 'gst_marchetti', name: 'RIVOTRIL 2 MG', dosage: 'C. 1/2', slot: 'afternoon', start_date: '2014-11-21', is_active: true },
   { id: 'med_10', guest_id: 'gst_marchetti', name: 'GARDENALE 50 MG', dosage: 'C. 1', slot: 'dinner', start_date: '2014-11-21', is_active: true },
   { id: 'med_11', guest_id: 'gst_marchetti', name: 'ZONEGRAN 100 MG', dosage: 'C. 2', slot: 'dinner', start_date: '2015-01-01', is_active: true },
   { id: 'med_12', guest_id: 'gst_marchetti', name: 'LEVETIRACETAM 500 MG', dosage: 'C. 1', slot: 'dinner', start_date: '2022-08-22', is_active: true },
   { id: 'med_13', guest_id: 'gst_marchetti', name: 'TACHIPIRINA 500 MG', dosage: 'C. 2', slot: 'as_needed', start_date: '2023-01-01', is_active: true, notes: 'SE T > 38.5' },
   { id: 'med_14', guest_id: 'gst_marchetti', name: 'TACHIPIRINA 500 MG', dosage: 'C. 1', slot: 'as_needed', start_date: '2023-01-01', is_active: true, notes: 'SE DOLORE ARTI INFERIORI' },
   // Morandi Carlo
   { id: 'med_20', guest_id: 'gst_morandi', name: 'METFORMINA 850 MG', dosage: 'C. 1', slot: 'breakfast', start_date: '2020-01-01', is_active: true },
   { id: 'med_21', guest_id: 'gst_morandi', name: 'RAMIPRIL 5 MG', dosage: 'C. 1', slot: 'breakfast', start_date: '2019-06-01', is_active: true },
   { id: 'med_22', guest_id: 'gst_morandi', name: 'INSULINA LANTUS', dosage: '14 UI', slot: 'dinner', start_date: '2021-03-15', is_active: true },
   // Ferretti Anna
   { id: 'med_30', guest_id: 'gst_ferretti', name: 'KEPPRA 500 MG', dosage: 'C. 1', slot: 'breakfast', start_date: '2018-03-01', is_active: true },
   { id: 'med_31', guest_id: 'gst_ferretti', name: 'KEPPRA 500 MG', dosage: 'C. 1', slot: 'dinner', start_date: '2018-03-01', is_active: true },
   { id: 'med_32', guest_id: 'gst_ferretti', name: 'DEPAKIN CHRONO 500 MG', dosage: 'C. 1', slot: 'breakfast', start_date: '2016-05-10', is_active: true },
   { id: 'med_33', guest_id: 'gst_ferretti', name: 'DEPAKIN CHRONO 500 MG', dosage: 'C. 1', slot: 'dinner', start_date: '2016-05-10', is_active: true },
   { id: 'med_34', guest_id: 'gst_ferretti', name: 'MICROPAM 10 MG', dosage: '1 fiala rettale', slot: 'as_needed', start_date: '2016-05-10', is_active: true, notes: 'Solo se crisi > 5 min' },
   // Fabbri Matteo
   { id: 'med_40', guest_id: 'gst_fabbri', name: 'RISPERIDONE 1 MG', dosage: 'C. 1', slot: 'breakfast', start_date: '2022-01-15', is_active: true },
   { id: 'med_41', guest_id: 'gst_fabbri', name: 'RISPERIDONE 1 MG', dosage: 'C. 1', slot: 'dinner', start_date: '2022-01-15', is_active: true },
   { id: 'med_42', guest_id: 'gst_fabbri', name: 'MELATONINA 3 MG', dosage: 'C. 1', slot: 'dinner', start_date: '2022-06-01', is_active: true },
   // Valentini Giuseppe
   { id: 'med_50', guest_id: 'gst_valentini', name: 'CARDIOASPIRIN 100 MG', dosage: 'C. 1', slot: 'lunch', start_date: '2019-11-01', is_active: true },
   { id: 'med_51', guest_id: 'gst_valentini', name: 'RAMIPRIL 2.5 MG', dosage: 'C. 1', slot: 'breakfast', start_date: '2019-11-01', is_active: true },
   { id: 'med_52', guest_id: 'gst_valentini', name: 'ATORVASTATINA 20 MG', dosage: 'C. 1', slot: 'dinner', start_date: '2019-11-01', is_active: true },
]

// ---------------------------------------------------------------------------
// DEMO PROFILES — derived from user + user_role + operator
// ---------------------------------------------------------------------------

export type DemoProfile = {
   id: string
   label: string
   subtitle: string
   description: string
   role: 'superadmin' | 'admin' | 'manager' | 'readonly' | 'operatore'
   scopeType: 'system' | 'facility' | 'unit' | 'guest' | null
   scopeId: string | null
   facility: string | null
   isFamily?: boolean
   avatar?: string | null
}

function getOperatorAvatar(userId: string): string | null {
   const op = operators.find((o) => o.user_id === userId)
   return op?.photo_url || null
}

export const demoProfiles: DemoProfile[] = [
   {
      id: 'usr_01',
      label: 'Marco Bianchi',
      subtitle: 'Direttore (Superadmin)',
      description: 'Accesso completo a tutte le strutture, tutti gli ospiti e tutti i servizi della cooperativa. Puo\' navigare liberamente tra Domus Laetitiae, Cascina Oremo e Villa Mossa.',
      role: 'superadmin',
      scopeType: 'system',
      scopeId: null,
      facility: null,
      avatar: getOperatorAvatar('usr_01'),
   },
   {
      id: 'usr_02',
      label: 'Sara Rossi',
      subtitle: 'Coordinatrice (Admin Domus Laetitiae)',
      description: 'Admin della facility Domus Laetitiae. Vede tutti gli ospiti della struttura e gli ospiti esterni che usano il servizio Ri-Abilitazione (condiviso con Cascina e Villa Mossa).',
      role: 'admin',
      scopeType: 'facility',
      scopeId: 'fac_domus',
      facility: 'fac_domus',
      avatar: getOperatorAvatar('usr_02'),
   },
   {
      id: 'usr_04',
      label: 'Luca Verdi',
      subtitle: 'Fisioterapista (Operatore base)',
      description: 'Assegnato al servizio Ri-Abilitazione, condiviso tra le 3 strutture. Vede gli ospiti di Domus, Cascina e Villa Mossa che usano il servizio. Puo\' navigare tra le strutture.',
      role: 'operatore',
      scopeType: null,
      scopeId: null,
      facility: 'fac_domus',
      avatar: getOperatorAvatar('usr_04'),
   },
   {
      id: 'usr_05',
      label: 'Anna Neri',
      subtitle: 'Coordinatrice (Admin Cascina Oremo)',
      description: 'Admin della facility Cascina Oremo. Vede tutti gli ospiti della struttura e il servizio Ri-Abilitazione dalla prospettiva del consumatore (servizio fornito da Domus).',
      role: 'admin',
      scopeType: 'facility',
      scopeId: 'fac_cascina',
      facility: 'fac_cascina',
      avatar: getOperatorAvatar('usr_05'),
   },
   {
      id: 'usr_morandi_r',
      label: 'Rosa Morandi',
      subtitle: 'Familiare (Morandi Carlo)',
      description: 'Portale famiglia. Vede solo i dati del figlio Carlo Morandi, ospite residenziale presso Domus Laetitiae nel nucleo Terra di Mezzo.',
      role: 'readonly',
      scopeType: 'guest',
      scopeId: 'gst_morandi',
      facility: 'fac_domus',
      isFamily: true,
      avatar: 'https://api.dicebear.com/9.x/micah/svg?seed=Rosa+Morandi&baseColor=f9c9b6&earringsProbability=40&hair=fonze,full,pixie&mouth=smile,smirk,laughing,pucker&backgroundColor=ffffff&facialHairProbability=0',
   },
]

// ---------------------------------------------------------------------------
// COMPOSABLE
// ---------------------------------------------------------------------------

export function useMockData() {
   return {
      facilities,
      professionalRoles,
      units,
      services,
      serviceUnits,
      sharedServices,
      groups,
      users,
      userRoles,
      operators,
      operatorServices,
      guests,
      guestServices,
      guestContacts,
      guestHealth,
      medications,
      roleDefaultPermissions,
      userPermissions,
      activityTypes,
      activityEvents,
      appointments,
      diaryEntries,
      diaryEntryGuests,
      diaryEntryOperators,
      incidents,
      incidentGuests,
      incidentOperators,
      lifeProjects,
      lifeProjectObjectives,
      threads,
      threadEntries,
      alerts,
      alertReads,
      operatorHistory,
      operatorAttachments,
      guestTransferRequests,
      guestHistory,
      guestAttachments,
      demoProfiles,
   }
}
